/**
 * App chrome for the Magic Capture prototype: the real design-system
 * NavDrawer with prototype-owned tabs (Home / Actions / Care / Help).
 *
 * Note: ChromeTemplate needs a data router (useMatches); the designs app uses
 * BrowserRouter, so we wrap NavDrawer directly.
 */
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { at, within } from '@/james-playground/magic-capture/mount';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

import {
  NavDrawer,
  type LinkItem,
} from '@karehero/llama/pwa/molecules/NavDrawer/NavDrawer';

export const PrototypeChrome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useKindeAuth();

  const links: LinkItem[] = [
    {
      icon: 'house-blank',
      label: 'Home',
      to: '/',
      onClick: () => navigate(at('/')),
    },
    {
      icon: 'calendar',
      label: 'Actions',
      to: '/actions',
      onClick: () => navigate(at('/actions')),
    },
    {
      icon: 'hand-holding-heart',
      label: 'Care',
      to: '/care',
      onClick: () => navigate(at('/care')),
    },
    {
      icon: 'message',
      label: 'Help',
      to: '/help',
      onClick: () => navigate(at('/help')),
    },
  ];

  return (
    <NavDrawer
      links={links}
      activePath={within(location.pathname)}
      accountInfoProps={{
        name: 'Olivia Patrick',
        role: 'Caring for Margaret',
        fallback: 'OP',
        isMenuDisabled: false,
        onSignOut: () => logout(),
      }}
    >
      <Outlet />
    </NavDrawer>
  );
};

export default PrototypeChrome;
